<template>
  <div :key="key" class="box">
    <p class="risk-tip">{{ riskText }}</p>
    <img
      v-if="imageInfo.url "
      class="image"
      :src="imageInfo.url"
      width="100%"
      :alt="statusText"
    />
  </div>
</template>

<script>

export default {
  props: {
    fundCode: String,
    mergeData: Object,
  },

  data() {
    return {
      imageLoaded: false,
      key: 0,
      statusText: '加载中',
    };
  },

  computed: {
    imageInfo() {
      return this.mergeData?.onePageRead || {};
    },

    riskText() {
      const manager = this.mergeData?.manager || '--';
      return `产品解读专题内容由【${manager}】制作出品，由【${manager}】对内容的真实准确和合法合规性负责，不代表天天基金的立场和观点。`;
    },
  },

  methods: {

  },
};
</script>

<style scoped>
.box {
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px;
  padding-bottom: 24px;
  margin-bottom: 64px;
  margin-top: 24px;
  padding: 16px;
}

.risk-tip {
  font-family: PingFangSC-Regular;
  font-size: 22px;
  color: #999999;
  margin-bottom: 24px;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  height: 400px;
  background-color: #ffffff;
}

.text {
  font-size: 30px;
  color: #666666;
}

.image {
  margin-bottom: 164px;
}
</style>
